<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-content">
        <div class="list">
          <el-table :data="VIPList" style="width: 100%">
            <el-table-column label="门店名称">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.fullName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="会员号">
              <template slot-scope="scope">
                <div>{{ scope.row.customerUserId }}</div>
              </template>
            </el-table-column>
            <el-table-column label="购次/消费">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.totalConsumeCount }}次/{{
                    scope.row.totalConsumeMoney.toFixed(1)
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="会员折扣">
              <template slot-scope="scope">
                <div>{{ scope.row.discount }}折</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="right">
              <template slot-scope="scope">
                <div class="float-right">
                  <el-button size="small" type="primary" @click="info(scope.$index)" plain
                    >详情</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            background
            layout="prev, pager, next, jumper"
            :total="VIPList.length"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      VIPList: [],
      pageSize: 5,
    };
  },
  mounted() {},
  methods: {
    handleSizeChange() {},
    handleCurrentChange() {},
    info(index) {},
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .list {
    width: 100%;
    padding: 0 20px;
  }
}
</style>
